import { Card, CircularProgress, Backdrop, Icon } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import usePageTitle from "app/pageTitle";

import MDButton from "theme/components/MDButton";
import axios from "axios.js";
import { useAwaitDialog } from "app/components/status_dialog";

function WhatsAppNumberInsightsPage() {
  const pageTitle = "WhatsApp - Number Insights";
  usePageTitle(pageTitle);

  const navigate = useNavigate();
  const { ref } = useParams();
  const statusDialog = useAwaitDialog();

  const [showLoading, setShowLoading] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);
  const [insights, setInsights] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);

      await axios
        .get(`/portal/wacc/businesses/numbers/${ref}/insights.json`)
        .then((result) => {
          setShowLoading(false);

          if (result.data.status === "success") {
            setInsights(result.data.data);
            setPageLoaded(true);
          } else {
            statusDialog.show(result.data.data.message, "error", "Request Failed");
          }
        })
        .catch(async () => {
          setShowLoading(false);

          await statusDialog.show(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`,
            "error",
            "Request Failed"
          );
        });
    };

    fetchData();
  }, [ref]);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <MDBox mt={1} mb={5}>
        {pageLoaded && (
          <MDBox>
            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={3}>
              <MDTypography variant="h6" fontWeight="medium">
                Number Insights
              </MDTypography>

              <MDButton
                variant="contained"
                color="dark"
                size="small"
                onClick={() => navigate(`/wacc/businesses/number/${ref}`)}
                startIcon={<Icon>arrow_back</Icon>}
              >
                Number
              </MDButton>
            </MDBox>

            <MDBox display="flex" flexWrap="wrap" gap={2}>
              <Card sx={{ minWidth: 180 }}>
                <MDBox p={2}>
                  <MDTypography variant="h6" fontWeight="medium">
                    Contacts
                  </MDTypography>
                  <MDTypography mt={1} variant="h4">
                    {insights.contacts}
                  </MDTypography>
                </MDBox>
              </Card>

              <Card sx={{ minWidth: 180 }}>
                <MDBox p={2}>
                  <MDTypography variant="h6" fontWeight="medium">
                    Conversations
                  </MDTypography>
                  <MDTypography mt={1} variant="h4">
                    {insights.conversations}
                  </MDTypography>
                </MDBox>
              </Card>

              <Card sx={{ minWidth: 180 }}>
                <MDBox p={2}>
                  <MDTypography variant="h6" fontWeight="medium">
                    Open Conversations
                  </MDTypography>
                  <MDTypography mt={1} variant="h4">
                    {insights.open_conversations}
                  </MDTypography>
                </MDBox>
              </Card>

              <Card sx={{ minWidth: 180 }}>
                <MDBox p={2}>
                  <MDTypography variant="h6" fontWeight="medium">
                    Closed Conversations
                  </MDTypography>
                  <MDTypography mt={1} variant="h4">
                    {insights.closed_conversations}
                  </MDTypography>
                </MDBox>
              </Card>

              <Card sx={{ minWidth: 180 }}>
                <MDBox p={2}>
                  <MDTypography variant="h6" fontWeight="medium">
                    Messages
                  </MDTypography>
                  <MDTypography mt={1} variant="h4">
                    {insights.messages}
                  </MDTypography>
                </MDBox>
              </Card>

              <Card sx={{ minWidth: 180 }}>
                <MDBox p={2}>
                  <MDTypography variant="h6" fontWeight="medium">
                    Incoming Messages
                  </MDTypography>
                  <MDTypography mt={1} variant="h4">
                    {insights.incoming_messages}
                  </MDTypography>
                </MDBox>
              </Card>

              <Card sx={{ minWidth: 180 }}>
                <MDBox p={2}>
                  <MDTypography variant="h6" fontWeight="medium">
                    Outgoing Messages
                  </MDTypography>
                  <MDTypography mt={1} variant="h4">
                    {insights.outgoing_messages}
                  </MDTypography>
                </MDBox>
              </Card>

              <Card sx={{ minWidth: 180 }}>
                <MDBox p={2}>
                  <MDTypography variant="h6" fontWeight="medium">
                    Sent
                  </MDTypography>
                  <MDTypography mt={1} variant="h4">
                    {insights.sent_messages}
                  </MDTypography>
                </MDBox>
              </Card>

              <Card sx={{ minWidth: 180 }}>
                <MDBox p={2}>
                  <MDTypography variant="h6" fontWeight="medium">
                    Delivered
                  </MDTypography>
                  <MDTypography mt={1} variant="h4">
                    {insights.delivered_messages}
                  </MDTypography>
                </MDBox>
              </Card>

              <Card sx={{ minWidth: 180 }}>
                <MDBox p={2}>
                  <MDTypography variant="h6" fontWeight="medium">
                    Read
                  </MDTypography>
                  <MDTypography mt={1} variant="h4">
                    {insights.read_messages}
                  </MDTypography>
                </MDBox>
              </Card>
            </MDBox>
          </MDBox>
        )}
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
}

export default WhatsAppNumberInsightsPage;